import React from 'react'
import styled from 'styled-components'
import Container from '../system/container/container'
import breakpoints from '../../styles/breakpoints'
import CroppedImg from '../cropped-img'
import PACEvent from '../../models/event/pac-event'
import { EventStatus, eventStatusToDisplayName } from '../../models/event/event-status'
import EventLivestreamVideoPlayer from '../stream-popout/event-livestream-video-player'
import { useIsLive, useStreamEvent } from '../stream-popout/stream-provider'

const bgBreakpoint = breakpoints.md

const StyledEventHero = styled.section`
  display: grid;
  filter: drop-shadow(${props => props.theme.shadows.close});
`

const EventHeroBG = styled.div`
  display: none;
  background-image: url('/images/event-hero.jpg');
  background-position: center 15%;

  @media (min-width: ${bgBreakpoint}) {
    display: block;
    grid-area: 1/1;
    clip-path: polygon(0 0, 100% 0, 100% 75%, 0 100%);
  }
`

const PromoImgContainer = styled(Container)`
  grid-area: 1/1;
  width: 100%;
  display: flex;
  justify-content: flex-end;
  flex-direction: column;

  @media (max-width: ${bgBreakpoint}) {
    padding: 0;
  }

  @media (min-width: ${bgBreakpoint}) {
    padding-top: ${props => props.theme.spacing.base600};
  }
`

const PromoImg = styled(CroppedImg)`
  box-shadow: ${props => props.theme.shadows.close};

  @media (min-width: ${bgBreakpoint}) {
    border-radius: 3px;
  }
`

const Player = styled.div`
  position: relative;
`

const EventHero = ({ event }: { event: PACEvent }) => {
  const isLive = useIsLive(event)
  const liveEvent = useStreamEvent()
  const image = event.promotionImage
  const eventActive = event.status === EventStatus.ACTIVE

  return (
    <StyledEventHero>
      <EventHeroBG aria-hidden="true" />

      <PromoImgContainer>
        {isLive ? (
          <Player>
            <EventLivestreamVideoPlayer event={liveEvent} />
          </Player>
        ) : (
          <PromoImg
            src={`${image.url}?w=1200&fit=fill`}
            alt={image.title}
            ratioX={21}
            ratioY={9}
            ribbon={!eventActive || !!event.ribbon}
            ribbonText={
              !eventActive
                ? eventStatusToDisplayName(event.status)
                : event.ribbon
                ? event.ribbon.text
                : ''
            }
            ribbonBackgroundColor={event.ribbon ? event.ribbon.backgroundColor : undefined}
            ribbonTextColor={event.ribbon ? event.ribbon.textColor : undefined}
            ribbonLarge
          />
        )}
      </PromoImgContainer>
    </StyledEventHero>
  )
}

export default EventHero
